
const HowItWorks = () => {
  const steps = [
    {
      number: "01",
      title: "Dream",
      description: "Submit your project idea through our simple form",
      icon: "ri-lightbulb-line"
    },
    {
      number: "02", 
      title: "Vote",
      description: "$Startup holders vote on which projects to support",
      icon: "ri-vote-line"
    },
    {
      number: "03",
      title: "Build", 
      description: "Selected projects receive funding and mentorship",
      icon: "ri-hammer-line"
    },
    {
      number: "04",
      title: "Rise",
      description: "Every success increases value for the entire community",
      icon: "ri-rocket-line"
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-blue-900 via-blue-950 to-black">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-20">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 rounded-full mb-8">
              <i className="ri-settings-3-line text-2xl text-white"></i>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              How It Works
            </h2>
            <p className="text-xl text-white/80 font-light max-w-2xl mx-auto">
              A simple 4-step process that transforms dreams into reality
            </p>
            <div className="w-24 h-1 bg-white mx-auto mt-8"></div>
          </div>

          {/* Steps */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="text-center group">
                {/* Step Number */}
                <div className="relative mb-8">
                  <div className="inline-flex items-center justify-center w-20 h-20 bg-white/10 rounded-full border-2 border-white/20 group-hover:border-white/40 transition-all duration-300">
                    <span className="text-2xl font-bold text-white">{step.number}</span>
                  </div>
                  {index < steps.length - 1 && (
                    <div className="hidden lg:block absolute top-10 left-full w-full h-0.5 bg-white/20"></div>
                  )}
                </div>

                {/* Icon */}
                <div className="inline-flex items-center justify-center w-16 h-16 bg-white/5 rounded-full mb-6 group-hover:bg-white/10 transition-all duration-300">
                  <i className={`${step.icon} text-2xl text-white`}></i>
                </div>

                {/* Content */}
                <h3 className="text-2xl font-bold text-white mb-4">
                  {step.title}
                </h3>
                <p className="text-white/80 font-light leading-relaxed">
                  {step.description}
                </p>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="text-center mt-16">
            <a
              href="https://forms.gle/2GE78MMrFUHBdtDW8"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center bg-white text-black px-8 py-4 rounded-full font-semibold text-lg hover:bg-blue-100 transition-all duration-300 transform hover:scale-105 hover:shadow-2xl whitespace-nowrap cursor-pointer"
            >
              Start Your Journey
              <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform duration-300"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
